export default __webpack_public_path__ + "static/media/bottombg03.01aafa61.png";